{
  "satis_urun": {
    "Baslik": "Satış Ürünleri",
    "Ad": "Ürün Adı",
    "Firma Adı": "Firma Adı",
    "Birim": "Birim",
    "Komisyon": "Komisyon",
    "Komisyon SM": "Komisyon SM",
    "Durum": "Durum",
    "Arama": "Arama",
    "Ara": "Ara",
    "Temizle": "Temizle",
    "Kapat": "Kapat",
    "Yenile": "Yenile",
    "Data Yenile": "Verileri Güncelle",
    "Ekle": "Ekle",
    "Filtrele": "Filtrele",
    "Duzenle": "Düzenle",
    "Sil": "Sil",
    "Kaydet": "Kaydet",
    "Guncelle": "Güncelle",
    "Vazgec": "Vazgeç",
    "Iptal": "İptal",
    "Birim Seçimi": "Birim Seçimi",
    "TL": "TL",
    "Dolar": "Dolar",
    "Hepsi": "Hepsi",
    "Aktif": "Aktif",
    "Pasif": "Pasif",
    "ARA": "Ara",
    "Komisyonlar": "Komisyon Aralıkları",
    "Kopyalama": "Hedef Kopyalama",
    "Kaynak Ürün": "Kaynak Ürün",
    "Kaynak Ünvan": "Kaynak Ünvan",
    "Hedef Ürün": "Hedef Ürün",
    "Hedef Ünvan": "Hedef Ünvan",
    "KopyalaUyari": "Dikkat! Hedef ürün ve ünvandaki eski komisyon kayıtları silinecektir.",
    "Kopyala": "Kopyala",
    "Islemler": "İşlemler"
  }
}
